import { render, staticRenderFns } from "./NearbyLights.vue?vue&type=template&id=36ca4b98&scoped=true&"
import script from "./NearbyLights.js?vue&type=script&lang=js&"
export * from "./NearbyLights.js?vue&type=script&lang=js&"
import style0 from "./NearbyLights.scss?vue&type=style&index=0&id=36ca4b98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ca4b98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
